import angular from "angular";

export default angular.module("services.TreeFilterService",[]).factory("TreeFilterService",
 [function TreeFilterService() {

   var tree = null;

   function setTree(_tree){
     tree = angular.copy(_tree);
     // console.log("saved tree",tree);
   }

   function getTree(){
     // console.log("retrieved tree: ", tree);
     return angular.copy(tree);
   }

   return {
     setTree : setTree,
     getTree : getTree
   };


}]).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/TreeFilterService.js